import { Thermostat } from "@mui/icons-material";
import "./index.scss";

function WeatherSection(props: any) {
  const { weather, zipcode } = props;
  const condition = zipcode && weather && weather.length > 0;
  return (
    <div className="weather-wrapper">
      {condition && (
        <>
          <div className="weather-wrapper-icon">
            <Thermostat />
          </div>
          <div className="weather-wrapper-info">
            <h2>{weather[0].temp}° F</h2>
            <p>HIGH: {weather[0].tempmax}ºF</p>
            <p>LOW: {weather[0].tempmin}ºF</p>
            <p>{weather[0].description}</p>
          </div>
        </>
      )}
      {!condition && <p>The location doesn't have enough information</p>}
    </div>
  );
}
export default WeatherSection;
